// 收缩菜单
export const ACCORD_INFO_PARK = [{
  src: './vtour_park/panos/01.tiles/thumb.jpg',
  text: '水景广场',
  id: '01',
}, {
  src: './vtour_park/panos/02.tiles/thumb.jpg',
  text: '主入口',
  id: '02',
},
{
  src: './vtour_park/panos/12.tiles/thumb.jpg',
  text: '园林方向',
  id: '12',
}, {
  src: './vtour_park/panos/03.tiles/thumb.jpg',
  text: '泳池入口',
  id: '03',
}, {
  src: './vtour_park/panos/04.tiles/thumb.jpg',
  text: '儿童泳池',
  id: '04',
}, {
  src: './vtour_park/panos/05.tiles/thumb.jpg',
  text: '成人泳池',
  id: '05',
}, {
  src: './vtour_park/panos/06.tiles/thumb.jpg',
  text: '阳光草坪',
  id: '06',
},
{
  src: './vtour_park/panos/07.tiles/thumb.jpg',
  text: '儿童乐园',
  id: '07',
},
{
  src: './vtour_park/panos/08.tiles/thumb.jpg',
  text: '屋顶花园',
  id: '08',
},
{
  src: './vtour_park/panos/11.tiles/thumb.jpg',
  text: '口袋花园',
  id: '11',
},
{
  src: './vtour_park/panos/09.tiles/thumb.jpg',
  text: '球场',
  id: '09',
},
{
  src: './vtour_park/panos/10.tiles/thumb.jpg',
  text: '活动中心',
  id: '10',
},
{
  src: './vtour_park/panos/13.tiles/thumb.jpg',
  text: '静谧花园',
  id: '13',
}];

// 小地图点位信息
export const POINT_INFO_PARK = {
  '01': { x: 71, y: 34, rotate: 200 },
  '02': { x: 68, y: 48, rotate: 270 },
  '03': { x: 52, y: 54, rotate: 140 },
  '04': { x: 55, y: 60, rotate: 200 },
  '05': { x: 61, y: 60, rotate: -90 },
  '06': { x: 46, y: 52, rotate: 30 },
  '07': { x: 48, y: 77, rotate: 210 },
  '08': { x: 43, y: 30, rotate: 200 },
  '09': { x: 30, y: 51, rotate: 120 },
  10: { x: 30, y: 42, rotate: 160 },
  11: { x: 24, y: 30, rotate: 120 },
  12: { x: 54, y: 48, rotate: 10 },
  13: { x: 36, y: 65, rotate: 240 },
};

// 收缩菜单
export const ACCORD_INFO_SAND = [{
  src: './vtour_sand/panos/01.tiles/thumb.jpg',
  text: '区域沙盘',
  id: '01',
},
// {
//   src: './vtour_sand/panos/04.tiles/thumb.jpg',
//   text: '区域沙盘北',
//   id: '04',
// },
{
  src: './vtour_sand/panos/02.tiles/thumb.jpg',
  text: '项目沙盘北',
  id: '02',
},
{
  src: './vtour_sand/panos/03.tiles/thumb.jpg',
  text: '项目沙盘南',
  id: '03',
},
];

export const SAND_TAG_INFO = [
  {
    text: '隐藏标签',
    group: 10,
  },
  {
    text: '信义造城',
    group: 6,
  },
  {
    text: '高效交通',
    group: 1,
  },
  {
    text: '繁华商业',
    group: 2,
  },
  {
    text: '醇熟教育',
    group: 3,
  },
  {
    text: '人文生态',
    group: 4,
  },
  {
    text: '健康呵护',
    group: 5,
  },
  {
    text: '总览',
    group: 0,
  },
];

export const HOUSE_TAG_INFO = [
  {
    text: '100m²',
    group: '01',
  },
  {
    text: '95m²',
    group: '02',
  },
  {
    text: '122m²',
    group: '03',
  },
];
// 收缩菜单
export const ACCORD_INFO_01 = [{
  src: './vtour_01/panos/06.tiles/thumb.jpg',
  text: '客厅',
  id: '06',
}, {
  src: './vtour_01/panos/01.tiles/thumb.jpg',
  text: '餐厅',
  id: '01',
}, {
  src: './vtour_01/panos/02.tiles/thumb.jpg',
  text: '厨房',
  id: '02',
}, {
  src: './vtour_01/panos/08.tiles/thumb.jpg',
  text: '阳台',
  id: '08',
}, {
  src: './vtour_01/panos/10.tiles/thumb.jpg',
  text: '主卧',
  id: '10',
}, {
  src: './vtour_01/panos/09.tiles/thumb.jpg',
  text: '主卫',
  id: '09',
}, {
  src: './vtour_01/panos/03.tiles/thumb.jpg',
  text: '次卧',
  id: '03',
}, {
  src: './vtour_01/panos/07.tiles/thumb.jpg',
  text: '卧室2',
  id: '07',
}, {
  src: './vtour_01/panos/04.tiles/thumb.jpg',
  text: '儿童房',
  id: '04',
}, {
  src: './vtour_01/panos/05.tiles/thumb.jpg',
  text: '公卫',
  id: '05',
}];

// 小地图点位信息
export const POINT_INFO_01 = {
  // '01': { x: 83, y: 27, rotate: 90 },
};

// 收缩菜单
export const ACCORD_INFO_02 = [{
  src: './vtour_02/panos/06.tiles/thumb.jpg',
  text: '客厅',
  id: '06',
}, {
  src: './vtour_02/panos/01.tiles/thumb.jpg',
  text: '餐厅',
  id: '01',
}, {
  src: './vtour_02/panos/02.tiles/thumb.jpg',
  text: '厨房',
  id: '02',
}, {
  src: './vtour_02/panos/07.tiles/thumb.jpg',
  text: '阳台',
  id: '07',
}, {
  src: './vtour_02/panos/09.tiles/thumb.jpg',
  text: '主卧',
  id: '09',
}, {
  src: './vtour_02/panos/08.tiles/thumb.jpg',
  text: '主卫',
  id: '08',
}, {
  src: './vtour_02/panos/03.tiles/thumb.jpg',
  text: '次卧',
  id: '03',
}, {
  src: './vtour_02/panos/04.tiles/thumb.jpg',
  text: '儿童房',
  id: '04',
}, {
  src: './vtour_02/panos/05.tiles/thumb.jpg',
  text: '公卫',
  id: '05',
}];

// 小地图点位信息
export const POINT_INFO_02 = {
  // '01': { x: 83, y: 27, rotate: 90 },
};

// 收缩菜单
export const ACCORD_INFO_03 = [{
  src: './vtour_03/panos/07.tiles/thumb.jpg',
  text: '客厅',
  id: '07',
}, {
  src: './vtour_03/panos/01.tiles/thumb.jpg',
  text: '餐厅',
  id: '01',
}, {
  src: './vtour_03/panos/02.tiles/thumb.jpg',
  text: '厨房',
  id: '02',
}, {
  src: './vtour_03/panos/08.tiles/thumb.jpg',
  text: '生活阳台',
  id: '08',
}, {
  src: './vtour_03/panos/09.tiles/thumb.jpg',
  text: '休闲阳台',
  id: '09',
}, {
  src: './vtour_03/panos/11.tiles/thumb.jpg',
  text: '主卧',
  id: '11',
}, {
  src: './vtour_03/panos/10.tiles/thumb.jpg',
  text: '主卫',
  id: '10',
}, {
  src: './vtour_03/panos/03.tiles/thumb.jpg',
  text: '次卧1',
  id: '03',
}, {
  src: './vtour_03/panos/04.tiles/thumb.jpg',
  text: '次卧2',
  id: '04',
}, {
  src: './vtour_03/panos/05.tiles/thumb.jpg',
  text: '儿童房',
  id: '05',
}, {
  src: './vtour_03/panos/06.tiles/thumb.jpg',
  text: '公卫',
  id: '06',
}];

// 小地图点位信息
export const POINT_INFO_03 = {
  // '01': { x: 83, y: 27, rotate: 90 },
};

export default {};
